import script from "./ChatComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ChatComponent.vue?vue&type=style&index=0&id=661efb67&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661efb67"]])

export default __exports__